import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { GenericModalComponent } from '../../../../generic-modal/generic-modal.component';
import { DigitalLogDailySummary, DigitalLogSummary } from 'src/app/models/digital-log/digital-log-summary.model';
import { ButtonIcons } from '../../../../action-button/models/button-icons.enum';
import { DigitalLogService } from 'src/app/services/sections/job/digital-log.service';
import { getDatePart } from 'src/app/services/helpers/date.helper';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from 'src/app/components/toast/models/toast-type.enum';
import { Toast } from 'src/app/components/toast/models/toast.model';
import { ReportContact } from 'src/app/models/report-contact';

@Component({
  selector: 'inspection-report-selector',
  templateUrl: './inspection-report-selector.component.html',
  styleUrls: ['./inspection-report-selector.component.scss']
})
export class InspectionReportSelectorComponent implements OnInit {

  @Output() public close = new EventEmitter<{ isVisible: boolean, postedMessage: string| null }>();
  @Input() public token: string;
  @Input() public set isVisible(value: boolean) {
		this._isVisible = value;
		if (this.reportSelectorModal) {
			this._isVisible ? this.reportSelectorModal.open() : this.reportSelectorModal.hide();
		
      if(this._isVisible && !this.firstLoadCompleted){
        this.loadNextPage();
        this.firstLoadCompleted = true;
      }
    }
	}
  @Input() public siteAddress: string;
  
  @ViewChild(GenericModalComponent) public reportSelectorModal: GenericModalComponent;
  private _isVisible = false;
  public readonly ButtonIcons = ButtonIcons;
  public isLoading: boolean = false;
  private pageCount: number = 0;
  private pageSize: number = 5;
  public totalRecords: number = 0;
  public onDemandFormCount: number = 0;
  private firstLoadCompleted: boolean = false;
  public canLoadMoreData: boolean = false;

  public  allDates: DigitalLogDailySummary[] = [];
  selectedDay: DigitalLogDailySummary;

  displayAdditionalRecipients: boolean = false;
  additionalRecipients: ReportContact[] = [];
  selectedAdditionalRecipients: number[] = [];

  public isSelected(id){
    return this.selectedAdditionalRecipients.includes(id);
  }

  public toggleSelectedRecipient($event: any, id: number){
    let index = this.selectedAdditionalRecipients.indexOf(id);
    if(index >= 0){
      this.selectedAdditionalRecipients.splice(index, 1);
    } else {
      this.selectedAdditionalRecipients.push(id);
    }
    
  }

  public get isVisible() {
		return this._isVisible;
	}
  
  constructor(
    private digitalLogService: DigitalLogService
    ) { }

  ngOnInit() {

  }

  resetData(){
    this.allDates = [];
    this.pageCount = 0;
    this.firstLoadCompleted = false;
    this.canLoadMoreData = false;
    this.selectedDay = null;

    this.displayAdditionalRecipients = false;
    this.selectedAdditionalRecipients = [];
  }

  toggleAdditionalRecipients(){
    this.displayAdditionalRecipients = true;
    this.loadContacts();
  }

  loadContacts() {
    this.isLoading = true;
    this.digitalLogService.getAdditionalRecipients(this.token).subscribe({
      next: (data: ReportContact[]) => {
        this.additionalRecipients = data;
        this.isLoading = false;
      }, 
      error: (error) => {
        this.isLoading = false;
        console.log(error);
      }
    })
  }

  loadNextPage(){
    if(this.isLoading){
      return;
    }
    this.pageCount = this.pageCount + 1;
    this.isLoading = true;
    this.digitalLogService.getOnDemandFormSummary(this.token, this.pageSize, this.pageCount).subscribe({
      next: (data: DigitalLogSummary) => {
        data.currentRecords.forEach(element => {
          this.allDates.push(element);
        });
        this.onDemandFormCount = data.onDemandFormCount || 0;
        this.totalRecords = data.totalRecords;
        this.canLoadMoreData = this.allDates.length < this.totalRecords;
        this.isLoading = false;
      }, 
      error: (error) => {
        this.isLoading = false;
        console.log(error);
      }
    });
  }

  canGenerateReport():boolean {
    return !this.isLoading && this.selectedDay != null;

  }

  onClickGenerateReport(){
    this.isLoading = true;
    var selectedContacts = [];
    if (this.displayAdditionalRecipients){
      selectedContacts = this.additionalRecipients.filter(c => this.selectedAdditionalRecipients.includes(c.userAccountId))
    }
    this.digitalLogService.generateNewReport(this.token, [this.selectedDay.day], selectedContacts).subscribe({
      next: (data: any) => {
        this.isLoading = false;
        this.onClose(`Report queued`);
      },
      error: (error: any) =>{
        this.isLoading = false;
        ToastService.pushToast({
					icon: 'error',
					text: 'Unable to generate report',
					type: ToastType.Error
				} as Toast);
      }
    });
  }

  onClose(postedMessage: string = null){
    this.resetData();
    this.close.emit({isVisible: false, postedMessage: postedMessage});
  }
}
